<div class="row">
    <div class="col-12">
        <h4 class="mb-2 py-1 font-header-1">List</h4>
    </div>
</div>

<div class="row mb-2">
    <div class="col ">
        <div widget class="card border-0 box-shadow">

            <div class="card-body  widget-body pb-0 pt-2 mb-4">
                <div class="row ">
                    <div class="col-6 ps-1">
                        <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                            data-bs-target="#Createmodal" (click)="CreateorUpdateList('CreatelistModal')"
                            *ngIf="fp.listcreate">Add
                            List</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn btn-sm text-right" (click)="clearlist('refresh')">
                            <i class="fa fa-repeat"> Refresh </i>
                        </button>
                    </div>
                </div>
                <!--========================================= ejs-grid ===================================================-->
                <div class="row mb-2 mt-2" style="min-height: 500px;">
                    <div class="col ps-1">
                        <ejs-grid #gridList [dataSource]='GridList | async' [allowPaging]='true'
                            [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                            [showColumnChooser]='true' [allowResizing]='true' [allowSorting]='true'
                            (dataStateChange)='dataChangeList($event)' (actionBegin)="onActionList($event)">
                            <e-columns>
                                <e-column minWidth=100 headerText="Actions" [showInColumnChooser]='false'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-edit-table" data-bs-toggle="modal"
                                            data-bs-target="#Createmodal"
                                            (click)="CreateorUpdateList('UpdatelistModal');getDetails(data)"><i
                                                class="fa fa-edit" *ngIf="fp.listupdate"></i></button>&nbsp;
                                        <button class="btn btn-delete-table" data-bs-toggle="modal"
                                            data-bs-target="#deleteListmodal" (click)="getDetails(data)"><i
                                                class="fa fa-trash" *ngIf="fp.listdelete"></i></button>
                                    </ng-template>
                                </e-column>
                                <e-column minWidth=100 field="listName" headerText="List Name" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column minWidth=100 field="listCode" headerText="List Code" type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='showLocationColumns()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true">
                                                </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- For Create or Update Modal -->
<span id="openListModal" data-bs-toggle="modal" data-bs-target="#Createmodal"></span>
<div class="modal fade" id="Createmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ListType == 'CreatelistModal'">
                        Create
                        List</span>
                    <span *ngIf="ListType == 'UpdatelistModal'">Update List</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="ListForm">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Name<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="LocationName" class="form-control"
                                [(ngModel)]="saveListFields.listName" />
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-lg-5">
                            <label>Code<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" formControlName="ListCode" class="form-control"
                                [(ngModel)]="saveListFields.listCode" />
                        </div>
                    </div>
                    <div class="row  mt-1">
                        <div class="col-lg-5">
                            <label>Is Available to agency
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="checkbox" formControlName="isAvailable"
                                [(ngModel)]="saveListFields.isAvailableToAgency" />
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-sm" (click)="SaveOrUpdateList();" [disabled]="!ListForm.valid || isSaveorUpdateBoolean"><span
                        *ngIf="ListType == 'CreatelistModal'"> Save &
                        Close</span> <span *ngIf="ListType == 'UpdatelistModal'">Update & Close</span> </button>
                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal"
                    (click)="clearlist('cancel')">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- For Delete Modal -->
<span id="closeListModal" data-bs-target="#deleteListmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleteListmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearlist('cancel')"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteList()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="clearlist('cancel')">No</button>
            </div>
        </div>
    </div>
</div>